var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 19,
    viewBox: "0 0 24 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #434343;\r\n      }\r\n\r\n      .cls-2 {\r\n        clip-path: url(#clip-path);\r\n      }\r\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1783",
    "data-name": "Rectangle 1783",
    className: "cls-1",
    width: 24,
    height: 19
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3501",
    "data-name": "Group 3501",
    transform: "translate(19318 -15336)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3408",
    "data-name": "Group 3408",
    transform: "translate(-19318 15336)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3407",
    "data-name": "Group 3407",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4745",
    "data-name": "Path 4745",
    className: "cls-1",
    d: "M21.192,18.68H2.36A2.363,2.363,0,0,1,0,16.32V2.36A2.363,2.363,0,0,1,2.36,0H21.192a2.363,2.363,0,0,1,2.361,2.36V16.32a2.363,2.363,0,0,1-2.361,2.36M2.36.812A1.55,1.55,0,0,0,.812,2.36V16.32A1.55,1.55,0,0,0,2.36,17.868H21.192a1.55,1.55,0,0,0,1.549-1.548V2.36A1.55,1.55,0,0,0,21.192.812Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4746",
    "data-name": "Path 4746",
    className: "cls-1",
    d: "M11.776,12.084A5.106,5.106,0,0,1,9.6,11.6L.233,7.194a.406.406,0,0,1,.346-.735l9.369,4.4a4.281,4.281,0,0,0,3.656,0l9.369-4.4a.406.406,0,0,1,.346.735l-9.369,4.4a5.106,5.106,0,0,1-2.174.487",
    transform: "translate(0 -1.206)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/Mail.007c5be6f77c1d9a3006d857bc100120.svg";
export { ForwardRef as ReactComponent };